import { cloneDeep } from 'lodash';
import { state as initialState } from '.';
export var mutations = {
    setForms: function (s, payload) { return s.forms = payload; },
    setLoadingForms: function (s, payload) { return s.loadingForms = payload; },
    reset: function (s) { return Object.assign(s, cloneDeep(initialState)); },
};
